import { RouteComponentProps } from "@reach/router";
import { FC } from "react";

export const Talk: FC<RouteComponentProps & { id?: string }> = ({ id }) => {
  return <div>Talk ID: {id}</div>;
};
